import React from "react";
import CategoryPage from "./CategoryPage";

function International({
  posts,
  publications
}) {

  return (
    <CategoryPage
      title="International"
      parentCategory="Articles"
      posts={posts}
      publications={publications}
    />
  );

}

export default International;